export type DfkYear = 2024 | 2025 | 2026;

export const dfkFacturesAnalysis = {
  "source": {
    "fileName": "Factures.xlsx",
    "driveFolder": "Drive / _bzinc / _2026 / DFK",
    "publicDownloadAvailable": false,
    "accessNote": "Fichier source conservé hors du répertoire public; utiliser le Drive interne BZ pour y accéder.",
    "analysisDate": "2026-07-29",
    "scope": "Factures DFK, années 2024-2026, montants avant taxes. Ligne 2027 exclue de la tendance 3 ans."
  },
  "kpis": {
    "total2024": 99900.0,
    "total2025": 103550.0,
    "total2026": 192050.0,
    "growth2026Vs2025": 85.5,
    "delta2026Vs2025": 88500.0,
    "threeYearTotal": 395500.0,
    "bz2026Share": 78.6
  },
  "yearlyTotals": [
    {
      "year": 2024,
      "total": 99900.0,
      "invoiceCount": 20,
      "growthVsPrevious": null,
      "deltaVsPrevious": null
    },
    {
      "year": 2025,
      "total": 103550.0,
      "invoiceCount": 20,
      "growthVsPrevious": 3.7,
      "deltaVsPrevious": 3650.0
    },
    {
      "year": 2026,
      "total": 192050.0,
      "invoiceCount": 21,
      "growthVsPrevious": 85.5,
      "deltaVsPrevious": 88500.0
    }
  ],
  "companies": [
    {
      "company": "BZ",
      "totals": {
        "2024": 63500.0,
        "2025": 61300.0,
        "2026": 151000.0
      },
      "counts": {
        "2024": 13,
        "2025": 13,
        "2026": 12
      },
      "delta2026Vs2025": 89700.0,
      "growth2026Vs2025": 146.3,
      "shareOf2026": 78.6
    },
    {
      "company": "BZ Telecom",
      "totals": {
        "2024": 4700.0,
        "2025": 7500.0,
        "2026": 10500.0
      },
      "counts": {
        "2024": 1,
        "2025": 1,
        "2026": 1
      },
      "delta2026Vs2025": 3000.0,
      "growth2026Vs2025": 40.0,
      "shareOf2026": 5.5
    },
    {
      "company": "Gestion Dany Bourassa",
      "totals": {
        "2024": 16000.0,
        "2025": 18000.0,
        "2026": 7500.0
      },
      "counts": {
        "2024": 1,
        "2025": 1,
        "2026": 1
      },
      "delta2026Vs2025": -10500.0,
      "growth2026Vs2025": -58.3,
      "shareOf2026": 3.9
    },
    {
      "company": "Gestion B2Z",
      "totals": {
        "2024": 4000.0,
        "2025": 2900.0,
        "2026": 6500.0
      },
      "counts": {
        "2024": 1,
        "2025": 1,
        "2026": 1
      },
      "delta2026Vs2025": 3600.0,
      "growth2026Vs2025": 124.1,
      "shareOf2026": 3.4
    },
    {
      "company": "Kilooctet",
      "totals": {
        "2024": 5300.0,
        "2025": 5850.0,
        "2026": 4900.0
      },
      "counts": {
        "2024": 1,
        "2025": 1,
        "2026": 1
      },
      "delta2026Vs2025": -950.0,
      "growth2026Vs2025": -16.2,
      "shareOf2026": 2.6
    },
    {
      "company": "9410-5053",
      "totals": {
        "2024": 2500.0,
        "2025": 2750.0,
        "2026": 3750.0
      },
      "counts": {
        "2024": 1,
        "2025": 1,
        "2026": 1
      },
      "delta2026Vs2025": 1000.0,
      "growth2026Vs2025": 36.4,
      "shareOf2026": 2.0
    },
    {
      "company": "Megaoctet",
      "totals": {
        "2024": 0,
        "2025": 2750.0,
        "2026": 3700.0
      },
      "counts": {
        "2024": 0,
        "2025": 1,
        "2026": 1
      },
      "delta2026Vs2025": 950.0,
      "growth2026Vs2025": 34.5,
      "shareOf2026": 1.9
    },
    {
      "company": "9442-6038",
      "totals": {
        "2024": 2500.0,
        "2025": 2500.0,
        "2026": 3500.0
      },
      "counts": {
        "2024": 1,
        "2025": 1,
        "2026": 1
      },
      "delta2026Vs2025": 1000.0,
      "growth2026Vs2025": 40.0,
      "shareOf2026": 1.8
    },
    {
      "company": "Fiducie DB",
      "totals": {
        "2024": 0,
        "2025": 0,
        "2026": 350.0
      },
      "counts": {
        "2024": 0,
        "2025": 0,
        "2026": 1
      },
      "delta2026Vs2025": 350.0,
      "growth2026Vs2025": null,
      "shareOf2026": 0.2
    },
    {
      "company": "Fiducie FD",
      "totals": {
        "2024": 0,
        "2025": 0,
        "2026": 350.0
      },
      "counts": {
        "2024": 0,
        "2025": 0,
        "2026": 1
      },
      "delta2026Vs2025": 350.0,
      "growth2026Vs2025": null,
      "shareOf2026": 0.2
    },
    {
      "company": "Gerri inc.",
      "totals": {
        "2024": 1400.0,
        "2025": 0,
        "2026": 0.0
      },
      "counts": {
        "2024": 1,
        "2025": 0,
        "2026": 0
      },
      "delta2026Vs2025": 0.0,
      "growth2026Vs2025": null,
      "shareOf2026": 0.0
    }
  ],
  "notableInvoices": [
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77697",
      "amount": 96000.0
    },
    {
      "client": "029407-ZX",
      "cie": "Gestion Dany Bourassa",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73574",
      "amount": 18000.0
    },
    {
      "client": "029407-ZX",
      "cie": "Gestion Dany Bourassa",
      "year": 2024,
      "date": "2025-01-13",
      "invoice": "71824",
      "amount": 16000.0
    },
    {
      "client": "029404-ZX",
      "cie": "BZ Telecom",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77645",
      "amount": 10500.0
    }
  ],
  "rows": [
    {
      "client": "029398-ZX",
      "cie": "9410-5053",
      "year": 2024,
      "date": "2025-01-13",
      "invoice": "71811",
      "amount": 2500.0
    },
    {
      "client": "029398-ZX",
      "cie": "9410-5053",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73522",
      "amount": 2750.0
    },
    {
      "client": "029398-ZX",
      "cie": "9410-5053",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77656",
      "amount": 3750.0
    },
    {
      "client": "029393-ZX",
      "cie": "9442-6038",
      "year": 2024,
      "date": "2025-01-13",
      "invoice": "71813",
      "amount": 2500.0
    },
    {
      "client": "029393-ZX",
      "cie": "9442-6038",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73523",
      "amount": 2500.0
    },
    {
      "client": "029393-ZX",
      "cie": "9442-6038",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77644",
      "amount": 3500.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2023-08-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2023-09-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2023-10-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2023-11-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2023-11-15",
      "invoice": "estimé",
      "amount": 3500.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2023-12-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2024-01-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2024-02-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2024-03-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2024-04-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2024-05-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2024-06-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2024,
      "date": "2024-07-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2024-08-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2024-09-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2024-10-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2024-11-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2024-12-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-01-06",
      "invoice": "71759",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-01-14",
      "invoice": "71835",
      "amount": 1300.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-02-04",
      "invoice": "72054",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-03-03",
      "invoice": "72244",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-04-01",
      "invoice": "72444",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-05-01",
      "invoice": "72658",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-06-02",
      "invoice": "73192",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2025,
      "date": "2025-07-02",
      "invoice": "73434",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2025-08-19",
      "invoice": "74142",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2025-09-03",
      "invoice": "74316",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2025-10-02",
      "invoice": "74644",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2025-11-03",
      "invoice": "74947",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2025-12-01",
      "invoice": "75225",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-01-07",
      "invoice": "75545",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-02-02",
      "invoice": "75722",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-03-03",
      "invoice": "76129",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-04-02",
      "invoice": "76401",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-05-04",
      "invoice": "76751",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-06-01",
      "invoice": "estimé",
      "amount": 5000.0
    },
    {
      "client": "029400-ZX",
      "cie": "BZ",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77697",
      "amount": 96000.0
    },
    {
      "client": "029404-ZX",
      "cie": "BZ Telecom",
      "year": 2024,
      "date": "2025-01-13",
      "invoice": "71814",
      "amount": 4700.0
    },
    {
      "client": "029404-ZX",
      "cie": "BZ Telecom",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73530",
      "amount": 7500.0
    },
    {
      "client": "029404-ZX",
      "cie": "BZ Telecom",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77645",
      "amount": 10500.0
    },
    {
      "client": "029396-ZX",
      "cie": "Fiducie DB",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77650",
      "amount": 350.0
    },
    {
      "client": "116304-ZX",
      "cie": "Fiducie FD",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77657",
      "amount": 350.0
    },
    {
      "client": "029412-ZX",
      "cie": "Gerri inc.",
      "year": 2024,
      "date": "2025-01-13",
      "invoice": "71815",
      "amount": 1400.0
    },
    {
      "client": "029401-ZX",
      "cie": "Gestion B2Z",
      "year": 2024,
      "date": "2025-01-13",
      "invoice": "71823",
      "amount": 4000.0
    },
    {
      "client": "029401-ZX",
      "cie": "Gestion B2Z",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73532",
      "amount": 2900.0
    },
    {
      "client": "029401-ZX",
      "cie": "Gestion B2Z",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77646",
      "amount": 6500.0
    },
    {
      "client": "029407-ZX",
      "cie": "Gestion Dany Bourassa",
      "year": 2024,
      "date": "2025-01-13",
      "invoice": "71824",
      "amount": 16000.0
    },
    {
      "client": "029407-ZX",
      "cie": "Gestion Dany Bourassa",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73574",
      "amount": 18000.0
    },
    {
      "client": "029407-ZX",
      "cie": "Gestion Dany Bourassa",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77649",
      "amount": 7500.0
    },
    {
      "client": "029399-ZX",
      "cie": "Kilooctet",
      "year": 2024,
      "date": "2025-01-14",
      "invoice": "71834",
      "amount": 5300.0
    },
    {
      "client": "029399-ZX",
      "cie": "Kilooctet",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73538",
      "amount": 5850.0
    },
    {
      "client": "029399-ZX",
      "cie": "Kilooctet",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77647",
      "amount": 4900.0
    },
    {
      "client": "029419-ZX",
      "cie": "Megaoctet",
      "year": 2025,
      "date": "2025-06-30",
      "invoice": "73541",
      "amount": 2750.0
    },
    {
      "client": "029419-ZX",
      "cie": "Megaoctet",
      "year": 2026,
      "date": "2026-06-30",
      "invoice": "77648",
      "amount": 3700.0
    }
  ]
} as const;
